import { render, staticRenderFns } from "./BlockType119.vue?vue&type=template&id=2ec2b923&scoped=true"
import script from "./BlockType119.vue?vue&type=script&lang=ts"
export * from "./BlockType119.vue?vue&type=script&lang=ts"
import style0 from "./BlockType119.vue?vue&type=style&index=0&id=2ec2b923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2b923",
  null
  
)

export default component.exports